import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    deviceType: '',
    navTitles: {},
    activeNav: 'index',
    businessList: [],
    cateLists: [],
    footerData: {}
  },
  mutations: {
    //es6语法，等同edit:funcion(){...}
    deviceType(state, value) {
      state.deviceType = value;
    },
    navTitles(state, value) {
      state.navTitles = value;
    },
    businessList(state, value) {
      state.businessList = value;
    },
    cateLists(state, value) {
      state.cateLists = value;
    },
    activeNav(state, value) {
      state.activeNav = value;
    },
    footerData(state, value) {
      state.footerData = value;
    },
  }
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js